import React, { useState } from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import PortalSidebar from "./PortalSidebar";
import PortalTopBar from "./PortalTopBar";
import "./portal.scss";

const muiV5Theme = createTheme();

const PortalLayout = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  React.useEffect(() => {
    document.body.style.backgroundColor = "#F1F5F9";
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, []);

  return (
    <ThemeProvider theme={muiV5Theme}>
      <div className="portal-shell">
        <PortalTopBar onMenuClick={() => setMobileOpen(true)} />

        <PortalSidebar
          mobileOpen={mobileOpen}
          onClose={() => setMobileOpen(false)}
        />

        <main className="portal-content">
          {children}
        </main>
      </div>
    </ThemeProvider>
  );
};

export default PortalLayout;
